/*
 File: content-mrk-ad.js
 Author: D McCleod
 Created: 1/29/2019
 Description: create a jQuery deffered object to handle callbacks in a sequence
              currently used in content marketing ad
 */

class DeferHandler {
    constructor() {
        this.deferred = $.Deferred();
        this.cue = [];
        this.deferred
            .done(this.cue)
            .done( () => { this.cue.length = 0 } );
    }

    addToCue(fn) {
        this.cue.push(fn);
        console.log('+ + +-> fn added to deferred cue');
    }

}

export { DeferHandler }